import { render, staticRenderFns } from "./giveGiftsAll.vue?vue&type=template&id=afbc6756&scoped=true&"
import script from "./giveGiftsAll.vue?vue&type=script&lang=js&"
export * from "./giveGiftsAll.vue?vue&type=script&lang=js&"
import style0 from "./giveGiftsAll.vue?vue&type=style&index=0&id=afbc6756&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbc6756",
  null
  
)

export default component.exports